import { ViewChild, Input } from "@angular/core";
import { CardComponent } from "../elements/card/card.component";
import { FormGroup } from "@angular/forms";

export abstract class HasCardComponent {
    @Input() group: FormGroup;
    @ViewChild(CardComponent) card: CardComponent;
}